<div [ngClass]="!isMobile && 'ms-5'">
	<app-navbar-planning
		[solution]="solution"
		[solutions]="solutions"
		[employeesList]="employeesList"
		[listMissionTypes]="listMissionTypes"
		[listMissionPlaces]="listMissionPlaces"
		[listCenterDepartments]="listCenterDepartments"
		[view]="view"
		[beginDate]="beginDate"
		[endDate]="endDate"
		[selectedCalendarDate]="selectedCalendarDate"
		[selectedWeek]="selectedWeek"
		[isModeListActive]="isModeListActive"
		[isActionsAllowed]="isPlanningEditable && !isLoadingSolution"
		[competences]="competences"
		[listBeneficiaires]="listBeneficiaires"
		[isLoadingSolution]="isLoadingSolution"
		[isModeAvailabilityActive]="isModeAvailabilityActive"
		[eventAvailabilitySaved]="this.eventsStore.availabilities"
		[canDisplayAvailabilityPlanning]="canDisplayAvailabilityPlanning"
		[listViewableCenters]="listViewableCenters"
		[selectedCenter]="selectedCenter"
		(setAlignedView)="setAlignedView($event)"
		(launchBuild)="buildSolution.launchBuild($event)"
		(setView)="setView($event)"
		(refreshView)="refreshView($event)"
		(getDataForPlanning)="getDataForPlanning($event)"
		(changeHourSegments)="changeHourSegments($event)"
		(addOrRemoveDay)="addOrRemoveDay($event)"
		(selectedCenterChangeEvent)="selectedCenterChange($event)"
		(openCreateVacationModaleEmitter)="openCreateVacationModale()"
	>
	</app-navbar-planning>
	<br />

	<div class="unselectable">
		<!-- DEBUT PLANNING -->
		<ng-template
			#weekViewHourSegmentTemplate
			let-segment="segment"
			let-locale="locale"
			let-segmentHeight="segmentHeight"
			let-isTimeLabel="isTimeLabel"
		>
			<div
				#segmentElement
				class="cal-hour-segment"
				[style.height.px]="segmentHeight"
				[class.cal-hour-start]="segment.isStart"
				[class.cal-after-hour-start]="!segment.isStart"
				[ngClass]="segment.cssClass"
				(mousedown)="
					startDragToCreate(
						selectedCalendarDate,
						weekStartsOn,
						segment,
						$event,
						segmentElement
					)
				"
			>
				<div class="cal-time" *ngIf="isTimeLabel">
					{{ segment.date | calendarDate : 'weekViewHour' : locale }}
				</div>
			</div>
		</ng-template>

		<div
			[ngSwitch]="view"
			id="MyDIv"
			*ngIf="
				!isModeListActive.active &&
				(view !== CalendarView.Day ||
					(view === CalendarView.Day &&
						solution &&
						(solution.plannings.length > 0 ||
							solution.unassignedMissions.length > 0)))
			"
		>
			<!-- Vue mois -->
			<!-- <mwl-calendar-month-view
				*ngSwitchCase="CalendarView.Month"
				[viewDate]="selectedCalendarDate"
				[weekStartsOn]="weekStartsOn"
				[weekendDays]="weekendDays"
				[events]="events"
				[locale]="locale"
				[refresh]="refresh"
				[activeDayIsOpen]="activeDayIsOpen"
				[excludeDays]="excludeDays"
				(dayClicked)="dayClicked($event.day, selectedCalendarDate)"
				(eventClicked)="eventEdit.handleEvent('Clicked', $event.event)"
				(eventTimesChanged)="eventTimesChanged($event)"
			>
			</mwl-calendar-month-view> -->

			<!-- Vue semaine alignée -->
			<div *ngIf="isWeekViewAlignedActive">
				<div
					class="scroll parent-scrollbar-top"
					*ngSwitchCase="CalendarView.Week"
				>
					<div
						class="col d-inline-block child-scrollbar-top"
						[ngClass]="{
							'custom-w-14': nbDayToDisplay === 7,
							'custom-w-16': nbDayToDisplay === 6,
							'custom-w-20': nbDayToDisplay === 5,
							'w-25': nbDayToDisplay === 4,
							'custom-w-33': nbDayToDisplay === 3,
							'w-50': nbDayToDisplay === 2,
							'w-100': nbDayToDisplay === 1
						}"
						*ngFor="let data of dataForWeekViewAligned"
					>
						<!-- AFFICHAGE DE LA DATE AU DESSUS DU CALENDRIER -->
						<div
							class="fw-bold text-center fs-5"
							[ngClass]="data.isHoliday ? 'holiday-color' : ''"
						>
							{{ formatDateHeaderWeekViewAligned(data) }}
						</div>
						<div
							class="fw-bold text-center holiday-color holiday-font-size"
							[ngClass]="!data.isHoliday && 'text-transparent'"
						>
							{{
								data.isHoliday
									? '(férié : ' +
									  this.convertObjectToCalEv.publicHolidays[
											this.dateUtils.convertFromDateToDateWithDash(data.date)
									  ] +
									  ')'
									: '---'
							}}
						</div>
						<app-week-view-aligned
							class="child-scrollbar-top"
							[viewDate]="data.date"
							[events]="data.events"
							[locale]="locale"
							[employees]="data.employees"
							[dayStartHour]="dayStartHour"
							[dayStartMinute]="0"
							[dayEndHour]="dayEndHour"
							[dayEndMinute]="0"
							[refresh]="refresh"
							[hourSegments]="hourSegments"
							(eventClicked)="eventEdit.handleEvent('Clicked', $event.event)"
							(getEmployeeIdOfClickedColumnOutput)="
								startDragToCreateForAlignedView($event, data.date)
							"
						>
						</app-week-view-aligned>
					</div>
				</div>
			</div>

			<!-- Vue semaine non alignée -->
			<div *ngIf="!isWeekViewAlignedActive">
				<mwl-calendar-week-view
					*ngSwitchCase="CalendarView.Week"
					[viewDate]="selectedCalendarDate"
					[weekStartsOn]="weekStartsOn"
					[weekendDays]="weekendDays"
					[events]="events"
					[locale]="locale"
					[dayStartHour]="dayStartHour"
					[dayStartMinute]="0"
					[dayEndHour]="dayEndHour"
					[dayEndMinute]="0"
					[refresh]="refresh"
					[excludeDays]="excludeDays"
					[hourSegments]="hourSegments"
					[hourSegmentTemplate]="weekViewHourSegmentTemplate"
					[tooltipAppendToBody]="true"
					(eventClicked)="eventEdit.handleEvent('Clicked', $event.event)"
				>
				</mwl-calendar-week-view>
			</div>
		</div>
		<div
			class="row"
			*ngIf="
				view === CalendarView.Day &&
				(!solution ||
					(solution.plannings.length === 0 &&
						solution.unassignedMissions.length === 0))
			"
		>
			<app-no-data-available></app-no-data-available>
		</div>

		<!-- FIN PLANNING -->
	</div>

	<app-event-edit
		[solution]="solution"
		[selectedCalendarDate]="selectedCalendarDate"
		[selectedWeek]="selectedWeek"
		[vacationTypes]="vacationTypes"
		[isEventEditable]="isPlanningEditable && !isLoadingSolution"
		[selectedServiceCenterId]="
			selectedCenter?.id
				? selectedCenter.id
				: currentUser.employee.serviceCenter.id
		"
		(getDataForPlanning)="getDataForPlanning($event)"
	></app-event-edit>

	<app-build-solution
		[solution]="solution"
		[employees]="employeesList"
		(setIsLoadingSolutionAndTriggerChangeDetection)="
			setIsLoadingSolutionAndTriggerChangeDetection($event)
		"
		(getDataForPlanning)="getDataForPlanning($event)"
		(launchEventBusSubscription)="launchEventBusSubscription()"
	></app-build-solution>

	<app-create-vacation
		*ngIf="isPlanningEditable"
		[dragToSelectEvent]="dragToSelectEvent"
		[vacationTypes]="vacationTypes"
		[isVacationCreationAllowed]="isPlanningEditable"
		(getDataForPlanning)="getDataForPlanning($event)"
		(cleanPlanning)="cleanPlanning($event)"
	>
	</app-create-vacation>

	<div *ngIf="isModeListActive.active">
		<app-list-planning
			[solution]="solution"
			[events]="events"
			(listViewEvent)="receiveListEvent($event)"
		></app-list-planning>
	</div>
</div>
